import { styled } from '@mui/material';
import React from 'react';
import diagonalLinesRight from '../../assets/patterns/diagonal_lines_right.png';

const Root = styled('div')(({ theme }) => ({
  borderTopLeftRadius: '16px',
  borderTopRightRadius: '16px',
  width: '100%',
  height: '100%',
  backgroundColor: theme.palette.porcelain['100Base'],
  padding: '1px',
}));

const Pattern = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  borderTopLeftRadius: '16px',
  borderTopRightRadius: '16px',
  background: `url(${diagonalLinesRight}), linear-gradient(179deg, #DDE1E3 0.67%, #E3E6E8 99.22%)`,
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  paddingRight: '16px',
}));

const IconSlot = styled('div')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '24px',
  height: '24px',
  cursor: 'pointer',
  userSelect: 'none',
}));

const HandleTop = ({
  children,
  height = '34px',
  minHeight = '34px',
  width = '100%',
  onIconClick,
  iconAriaLabel = 'handle action',
  ...props
}) => {
  const handleKeyDown = (e) => {
    if (!onIconClick) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onIconClick();
    }
  };
  return (
    <Root
      sx={{
        width: width,
        minHeight: minHeight,
        height: height,
      }}
      {...props}
    >
      <Pattern>
        {onIconClick ? (
          <IconSlot
            role="button"
            tabIndex={0}
            aria-label={iconAriaLabel}
            onClick={onIconClick}
            onKeyDown={handleKeyDown}
          >
            {children}
          </IconSlot>
        ) : (
          children
        )}
      </Pattern>
    </Root>
  );
};

export default HandleTop;
